import { apiDelete, apiGet, apiPost, apiPut, ApiError } from '../../lib/apiClient';
import type {
  EmailDoc,
  EmailDocIssue,
  EmailLanguage,
  EmailPreview,
  EmailTemplateDetail,
  EmailTemplateSummary,
  EmailTemplateVersion,
} from './types';

const BASE = '/email-templates/admin';

export const listTemplates = () =>
  apiGet<{ templates: EmailTemplateSummary[] }>(BASE).then((r) => r.templates);

/** Every email rendered as it would be sent now, with sample values: the gallery thumbnails. */
export const listPreviews = (language: EmailLanguage) =>
  apiGet<{ previews: Record<string, { subject: string; html: string }> }>(
    `${BASE}/previews/${language}`,
  ).then((r) => r.previews);

export const readTemplate = (key: string) => apiGet<EmailTemplateDetail>(`${BASE}/${key}`);

export const previewTemplate = (key: string, language: EmailLanguage, doc: EmailDoc) =>
  apiPost<EmailPreview>(`${BASE}/${key}/${language}/preview`, { doc });

export const publishTemplate = (key: string, language: EmailLanguage, doc: EmailDoc, note?: string) =>
  apiPut<EmailTemplateVersion>(`${BASE}/${key}/${language}`, { doc, ...(note ? { note } : {}) });

export const restoreVersion = (key: string, versionId: string) =>
  apiPost<EmailTemplateVersion>(`${BASE}/${key}/versions/${versionId}/restore`);

export const resetTemplate = (key: string, language: EmailLanguage) =>
  apiDelete<{ reset: boolean }>(`${BASE}/${key}/${language}`);

/** The per-field reasons the backend gave for refusing a publish. */
export function issuesFrom(error: unknown): EmailDocIssue[] {
  if (!(error instanceof ApiError)) return [];
  const body = error.errors as { issues?: EmailDocIssue[] } | undefined;
  return Array.isArray(body?.issues) ? body.issues : [];
}

export function messageFrom(error: unknown): string {
  return error instanceof ApiError ? error.message : 'Request failed';
}
